import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Footer from './components/Footer';
// import Squares from './components/Background';
import { AnimatedGridPattern } from './components/Background-magic';
import { cn } from "./components/cn"

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <>
    <AnimatedGridPattern
      numSquares={30}
      maxOpacity={0.1}
      duration={3}
      repeatDelay={1}
      className={cn(
        "[mask-image:radial-gradient(900px_circle_at_center,white,transparent)] fixed",
        "inset-x-0 inset-y-[-30%] h-[200%] skew-y-12"
      )}
    />
    <div className="flex flex-grow space-y-8 text-text flex-col min-h-screen">
      <div className='flex-1'>
        <App />
      </div>
      <Footer />

    </div>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
